import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm" data-id="element-157">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-158">
        <div className="flex items-center space-x-2" data-id="element-159">
          <div className="h-10 w-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center shadow-md" data-id="element-160">
            <span className="text-white text-xs font-bold" data-id="element-161">AI</span>
          </div>
          <div className="flex flex-col" data-id="element-162">
            <span className="text-xl font-bold text-gray-900 tracking-tight leading-tight" data-id="element-163">
              Swedenmark AI
            </span>
            <span className="text-xs text-gray-500 font-medium tracking-wide hidden sm:block" data-id="element-164">
              Cut costs. Grow revenue. Free your team.
            </span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-165">
          <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors font-medium" data-id="element-166">
            About
          </a>
          <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors font-medium" data-id="element-167">
            Services
          </a>
          <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors font-medium" data-id="element-168">
            Contact
          </a>
          <a href="#contact" className="bg-blue-600 text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors shadow-sm" data-id="element-169">
            Book a Call
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-600 p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-170">
          {isMenuOpen ? <XIcon size={24} data-id="element-171" /> : <MenuIcon size={24} data-id="element-172" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 py-4 absolute w-full shadow-lg" data-id="element-173">
          <div className="container mx-auto px-4 flex flex-col space-y-4" data-id="element-174">
            <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-175">
              About
            </a>
            <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-176">
              Services
            </a>
            <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-177">
              Contact
            </a>
            <a href="#contact" className="bg-blue-600 text-white px-4 py-3 rounded-lg text-center font-semibold hover:bg-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-178">
              Book a Call
            </a>
          </div>
        </div>}
    </header>;
}